import { deliverySchema, deliverySourceSchema, deliveryStatusSchema, } from '#src/deliveries/deliveries.contract.js';
import { definePolicy, listQuerySchema } from '#src/rsql/index.js';
const text = {
    type: 'string',
    wildcards: true,
    caseInsensitive: true,
};
/** O que `GET /api/deliveries` deixa filtrar, ordenar e pedir. */
export const deliveriesPolicy = definePolicy({
    fields: {
        id: { type: 'uuid' },
        recipientEmail: { ...text, sortable: true },
        summary: text,
        source: { type: 'enum', values: deliverySourceSchema.options },
        status: {
            type: 'enum',
            values: deliveryStatusSchema.options,
            sortable: true,
        },
        attempts: { type: 'integer', sortable: true },
        createdAt: { type: 'datetime', sortable: true },
        finishedAt: { type: 'datetime', sortable: true },
        error: text,
        'requestedBy.email': text,
        'requestedBy.name': text,
        routineRunId: { type: 'uuid' },
        resendOf: { type: 'uuid' },
    },
    defaultSort: [{ field: 'createdAt', direction: 'desc' }],
    selectable: deliverySchema.keyof().options,
});
export const deliveriesQuerySchema = listQuerySchema(deliveriesPolicy);
//# sourceMappingURL=deliveries.policy.js.map